var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55634 1.89336L3.4376 3.06211C2.71885 3.33086 2.13135 4.18085 2.13135 4.9496V9.59334C2.13135 10.3308 2.61885 11.2996 3.2126 11.7433L5.9001 13.7496C6.78135 14.4121 8.23134 14.4121 9.11259 13.7496L11.8001 11.7433C12.3938 11.2996 12.8813 10.3308 12.8813 9.59334V4.9496C12.8813 4.18085 12.2938 3.33086 11.5751 3.06211L8.45634 1.89336C7.92509 1.69961 7.07509 1.69961 6.55634 1.89336Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49981 7.32501C7.47481 7.32501 7.44356 7.32501 7.41856 7.32501C6.83106 7.30626 6.3623 6.81876 6.3623 6.22501C6.3623 5.61876 6.85606 5.125 7.46231 5.125C8.06856 5.125 8.56232 5.61876 8.56232 6.22501C8.55607 6.82501 8.08731 7.30626 7.49981 7.32501Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25615 9.07461C5.65615 9.47461 5.65615 10.1309 6.25615 10.5309C6.9374 10.9871 8.05615 10.9871 8.7374 10.5309C9.3374 10.1309 9.3374 9.47461 8.7374 9.07461C8.0624 8.61836 6.94365 8.61836 6.25615 9.07461Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmins);
export default __webpack_public_path__ + "static/media/admins.c096a7bd9208731d600868cb3b1577bd.svg";
export { ForwardRef as ReactComponent };